'use client'
import React, { createContext, useState, useEffect, useContext } from "react";
import Loader from "../Components/Loader";
import { loadCreds } from "../lib/apiCaller";

const ConfigContext = createContext();

export const useConfig = () => useContext(ConfigContext);

export const ConfigProvider = ({ children }) => {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadCreds()
            .then((data) => setConfig(data))
            .catch(() => setConfig(null))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <Loader />;

    return (
        <ConfigContext.Provider value={config}>
            {children}
        </ConfigContext.Provider>
    );
}; 